/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Equipment,
  EquipmentInput,
  EquipmentParams,
  Equipments,
  FilterOptionsList,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Equipment list
 */
export const equipment = (
    params?: MaybeRefOrGetter<EquipmentParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Equipments>(
      {url: `/equipment`, method: 'GET',
        params, signal
    },
      );
    }




export const getEquipmentQueryKey = (params?: MaybeRefOrGetter<EquipmentParams>,) => {
    return [
    'equipment', ...(params ? [params] : [])
    ] as const;
    }


export const getEquipmentQueryOptions = <TData = Awaited<ReturnType<typeof equipment>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<EquipmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipment>>> = ({ signal }) => equipment(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>
}

export type EquipmentQueryResult = NonNullable<Awaited<ReturnType<typeof equipment>>>
export type EquipmentQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Equipment list
 */

export function useEquipment<TData = Awaited<ReturnType<typeof equipment>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<EquipmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment item types
 */
export const equipmentItemTypes = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/equipment/item_type_filters`, method: 'GET', signal
    },
      );
    }




export const getEquipmentItemTypesQueryKey = () => {
    return [
    'equipment','item_type_filters'
    ] as const;
    }


export const getEquipmentItemTypesQueryOptions = <TData = Awaited<ReturnType<typeof equipmentItemTypes>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentItemTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentItemTypes>>> = ({ signal }) => equipmentItemTypes(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypes>>, TError, TData>
}

export type EquipmentItemTypesQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentItemTypes>>>
export type EquipmentItemTypesQueryError = ErrorType<StandardError>


/**
 * @summary Equipment item types
 */

export function useEquipmentItemTypes<TData = Awaited<ReturnType<typeof equipmentItemTypes>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentItemTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment slots
 */
export const equipmentSlots = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/equipment/slots`, method: 'GET', signal
    },
      );
    }




export const getEquipmentSlotsQueryKey = () => {
    return [
    'equipment','slots'
    ] as const;
    }


export const getEquipmentSlotsQueryOptions = <TData = Awaited<ReturnType<typeof equipmentSlots>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentSlots>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentSlotsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentSlots>>> = ({ signal }) => equipmentSlots(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentSlots>>, TError, TData>
}

export type EquipmentSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentSlots>>>
export type EquipmentSlotsQueryError = ErrorType<StandardError>


/**
 * @summary Equipment slots
 */

export function useEquipmentSlots<TData = Awaited<ReturnType<typeof equipmentSlots>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentSlots>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentSlotsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment types
 */
export const equipmentTypes = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/equipment/type_filters`, method: 'GET', signal
    },
      );
    }




export const getEquipmentTypesQueryKey = () => {
    return [
    'equipment','type_filters'
    ] as const;
    }


export const getEquipmentTypesQueryOptions = <TData = Awaited<ReturnType<typeof equipmentTypes>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentTypes>>> = ({ signal }) => equipmentTypes(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentTypes>>, TError, TData>
}

export type EquipmentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentTypes>>>
export type EquipmentTypesQueryError = ErrorType<StandardError>


/**
 * @summary Equipment types
 */

export function useEquipmentTypes<TData = Awaited<ReturnType<typeof equipmentTypes>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment weapon classes
 */
export const equipmentWeaponClasses = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/equipment/weapon_class_filters`, method: 'GET', signal
    },
      );
    }




export const getEquipmentWeaponClassesQueryKey = () => {
    return [
    'equipment','weapon_class_filters'
    ] as const;
    }


export const getEquipmentWeaponClassesQueryOptions = <TData = Awaited<ReturnType<typeof equipmentWeaponClasses>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentWeaponClasses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentWeaponClassesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentWeaponClasses>>> = ({ signal }) => equipmentWeaponClasses(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentWeaponClasses>>, TError, TData>
}

export type EquipmentWeaponClassesQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentWeaponClasses>>>
export type EquipmentWeaponClassesQueryError = ErrorType<StandardError>


/**
 * @summary Equipment weapon classes
 */

export function useEquipmentWeaponClasses<TData = Awaited<ReturnType<typeof equipmentWeaponClasses>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentWeaponClasses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentWeaponClassesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Equipment
 */
export const destroyEquipment = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Equipment>(
      {url: `/equipment/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyEquipmentMutationKey = () => ['destroyEquipment'] as const;

export const getDestroyEquipmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyEquipment>>, TError,DestroyEquipmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyEquipment>>, TError,DestroyEquipmentMutationVariables, TContext> => {

const mutationKey = getDestroyEquipmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyEquipment>>, DestroyEquipmentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyEquipment(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyEquipmentMutationResult = NonNullable<Awaited<ReturnType<typeof destroyEquipment>>>

    export type DestroyEquipmentMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyEquipmentMutationVariables = {id: string}

    /**
 * @summary Destroy Equipment
 */
export const useDestroyEquipment = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyEquipment>>, TError,DestroyEquipmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyEquipment>>,
        TError,
        DestroyEquipmentMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyEquipmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Equipment Detail
 */
export const equipmentDetail = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Equipment>(
      {url: `/equipment/${id}`, method: 'GET', signal
    },
      );
    }




export const getEquipmentDetailQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'equipment',id
    ] as const;
    }


export const getEquipmentDetailQueryOptions = <TData = Awaited<ReturnType<typeof equipmentDetail>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentDetailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentDetail>>> = ({ signal }) => equipmentDetail(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentDetail>>, TError, TData>
}

export type EquipmentDetailQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentDetail>>>
export type EquipmentDetailQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Equipment Detail
 */

export function useEquipmentDetail<TData = Awaited<ReturnType<typeof equipmentDetail>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentDetailQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Equipment
 */
export const updateEquipment = (
    id: MaybeRefOrGetter<string>,
    equipmentInput: MaybeRefOrGetter<EquipmentInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
equipmentInput = toValue(equipmentInput);

      return axiosClient<Equipment>(
      {url: `/equipment/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: equipmentInput, signal
    },
      );
    }




export const getUpdateEquipmentMutationKey = () => ['updateEquipment'] as const;

export const getUpdateEquipmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEquipment>>, TError,UpdateEquipmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateEquipment>>, TError,UpdateEquipmentMutationVariables, TContext> => {

const mutationKey = getUpdateEquipmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEquipment>>, UpdateEquipmentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateEquipment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEquipmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateEquipment>>>
    export type UpdateEquipmentMutationBody = EquipmentInput
    export type UpdateEquipmentMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateEquipmentMutationVariables = {id: string;data: EquipmentInput}

    /**
 * @summary Update Equipment
 */
export const useUpdateEquipment = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEquipment>>, TError,UpdateEquipmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateEquipment>>,
        TError,
        UpdateEquipmentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateEquipmentMutationOptions(options), queryClient);
    }
